export default __webpack_public_path__ + "static/media/error.6a190a72.svg";